var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatewayPatternLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 500,
    viewBox: "0 0 403 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-200.3 -51.9912L-218.819 -70.2224L-234.396 -54.8836L-227.64 -48.2313L-218.819 -56.9155L-213.818 -51.9912L-230.578 -35.488L-247.337 -51.9912L-230.578 -68.4944L-227.85 -65.8078L-221.091 -72.4647L-230.578 -81.8013L-260.852 -51.9912L-230.578 -22.1765L-200.3 -51.9912Z",
    fill: "url(#paint0_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.23 -51.9912L-147.749 -70.2224L-163.326 -54.8836L-156.568 -48.2313L-147.749 -56.9155L-142.748 -51.9912L-159.506 -35.488L-176.267 -51.9912L-159.506 -68.4944L-156.778 -65.8078L-150.021 -72.4647L-159.506 -81.8013L-189.782 -51.9912L-159.506 -22.1765L-129.23 -51.9912Z",
    fill: "url(#paint1_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.3569 -52.1899L-76.8755 -70.4211L-92.4529 -55.0823L-85.6964 -48.4277L-76.8755 -57.1143L-71.8747 -52.1899L-88.6328 -35.6867L-105.393 -52.1899L-88.6328 -68.6932L-85.9044 -66.0065L-79.1479 -72.6635L-88.6328 -82L-118.909 -52.1899L-88.6328 -22.3752L-58.3569 -52.1899Z",
    fill: "url(#paint2_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5166 -51.9912L-6.00195 -70.2224L-21.5794 -54.8836L-14.8229 -48.2313L-6.00195 -56.9155L-1.00116 -51.9912L-17.7616 -35.488L-34.5197 -51.9912L-17.7616 -68.4944L-15.0333 -65.8078L-8.27441 -72.4647L-17.7616 -81.8013L-48.0351 -51.9912L-17.7616 -22.1765L12.5166 -51.9912Z",
    fill: "url(#paint3_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5865 -51.9912L65.0679 -70.2224L49.4905 -54.8836L56.247 -48.2313L65.0679 -56.9155L70.0687 -51.9912L53.3106 -35.488L36.5502 -51.9912L53.3106 -68.4944L56.039 -65.8078L62.7955 -72.4647L53.3106 -81.8013L23.0348 -51.9912L53.3106 -22.1765L83.5865 -51.9912Z",
    fill: "url(#paint4_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46 -52.1899L135.941 -70.4211L120.364 -55.0823L127.121 -48.4277L135.941 -57.1143L140.942 -52.1899L124.182 -35.6867L107.424 -52.1899L124.182 -68.6932L126.91 -66.0065L133.669 -72.6635L124.182 -82L93.9083 -52.1899L124.182 -22.3752L154.46 -52.1899Z",
    fill: "url(#paint5_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.333 -51.9912L206.813 -70.2224L191.235 -54.8836L197.994 -48.2313L206.813 -56.9155L211.816 -51.9912L195.055 -35.488L178.295 -51.9912L195.055 -68.4944L197.784 -65.8078L204.54 -72.4647L195.055 -81.8013L164.782 -51.9912L195.055 -22.1765L225.333 -51.9912Z",
    fill: "url(#paint6_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.403 -51.9912L277.885 -70.2224L262.307 -54.8836L269.064 -48.2313L277.885 -56.9155L282.886 -51.9912L266.125 -35.488L249.367 -51.9912L266.125 -68.4944L268.854 -65.8078L275.612 -72.4647L266.125 -81.8013L235.852 -51.9912L266.125 -22.1765L296.403 -51.9912Z",
    fill: "url(#paint7_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.277 -52.1899L348.756 -70.4211L333.179 -55.0823L339.937 -48.4277L348.756 -57.1143L353.759 -52.1899L336.999 -35.6867L320.238 -52.1899L336.999 -68.6932L339.727 -66.0065L346.484 -72.6635L336.999 -82L306.725 -52.1899L336.999 -22.3752L367.277 -52.1899Z",
    fill: "url(#paint8_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.448 -13.3754L-253.967 -31.6065L-269.544 -16.2678L-262.788 -9.61317L-253.967 -18.2997L-248.966 -13.3754L-265.727 3.12783L-282.485 -13.3754L-265.727 -29.8786L-262.998 -27.192L-256.239 -33.8489L-265.727 -43.1854L-296 -13.3754L-265.727 16.4394L-235.448 -13.3754Z",
    fill: "url(#paint9_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.724 16.4394L403 -13.3754L384.481 -31.6065L368.904 -16.2678L375.661 -9.61317L384.481 -18.2997L389.482 -13.3754L372.724 3.12783L355.964 -13.3754L372.724 -29.8786L375.453 -27.192L382.209 -33.8489L372.724 -43.1854L342.448 -13.3754L372.724 16.4394Z",
    fill: "url(#paint10_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-194.654 16.4394L-164.378 -13.3754L-182.897 -31.6065L-198.474 -16.2678L-191.716 -9.61317L-182.897 -18.2997L-177.896 -13.3754L-194.654 3.12783L-211.415 -13.3754L-194.654 -29.8786L-191.926 -27.192L-185.169 -33.8489L-194.654 -43.1854L-224.93 -13.3754L-194.654 16.4394Z",
    fill: "url(#paint11_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-123.783 16.2406L-93.5049 -13.5718L-112.023 -31.8053L-127.601 -16.4665L-120.844 -9.81192L-112.023 -18.4961L-107.023 -13.5718L-123.783 2.93142L-140.541 -13.5718L-123.783 -30.075L-121.055 -27.3884L-114.296 -34.0453L-123.783 -43.3842L-154.057 -13.5718L-123.783 16.2406Z",
    fill: "url(#paint12_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.9096 16.4394L-22.6314 -13.3754L-41.15 -31.6065L-56.7274 -16.2678L-49.9709 -9.61317L-41.15 -18.2997L-36.1492 -13.3754L-52.9096 3.12783L-69.67 -13.3754L-52.9096 -29.8786L-50.1813 -27.192L-43.4224 -33.8489L-52.9096 -43.1854L-83.1831 -13.3754L-52.9096 16.4394Z",
    fill: "url(#paint13_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1626 16.4394L48.4384 -13.3754L29.9199 -31.6065L14.3425 -16.2678L21.099 -9.61317L29.9199 -18.2997L34.9207 -13.3754L18.1626 3.12783L1.40216 -13.3754L18.1626 -29.8786L20.8886 -27.192L27.6475 -33.8489L18.1626 -43.1854L-12.1132 -13.3754L18.1626 16.4394Z",
    fill: "url(#paint14_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0338 16.2406L119.312 -13.5718L100.793 -31.8053L85.216 -16.4665L91.9725 -9.81192L100.793 -18.4961L105.794 -13.5718L89.0338 2.93142L72.2733 -13.5718L89.0338 -30.075L91.7621 -27.3884L98.521 -34.0453L89.0338 -43.3842L58.7603 -13.5718L89.0338 16.2406Z",
    fill: "url(#paint15_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.907 16.4394L190.183 -13.3754L171.665 -31.6065L156.087 -16.2678L162.846 -9.61317L171.665 -18.2997L176.665 -13.3754L159.907 3.12783L143.147 -13.3754L159.907 -29.8786L162.636 -27.192L169.392 -33.8489L159.907 -43.1854L129.631 -13.3754L159.907 16.4394Z",
    fill: "url(#paint16_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.977 16.4394L261.255 -13.3754L242.737 -31.6065L227.159 -16.2678L233.916 -9.61317L242.737 -18.2997L247.738 -13.3754L230.977 3.12783L214.219 -13.3754L230.977 -29.8786L233.705 -27.192L240.464 -33.8489L230.977 -43.1854L200.704 -13.3754L230.977 16.4394Z",
    fill: "url(#paint17_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.851 16.2406L332.126 -13.5718L313.608 -31.8053L298.031 -16.4665L304.789 -9.81192L313.608 -18.4961L318.609 -13.5718L301.851 2.93142L285.09 -13.5718L301.851 -30.075L304.579 -27.3884L311.336 -34.0453L301.851 -43.3842L271.575 -13.5718L301.851 16.2406Z",
    fill: "url(#paint18_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-247.337 25.1469L-230.578 8.64371L-227.85 11.3303L-221.091 4.67339L-230.578 -4.66315L-260.852 25.1469L-230.578 54.9616L-200.3 25.1469L-218.819 6.91575L-234.396 22.2545L-227.64 28.9068L-218.819 20.2226L-213.818 25.1469L-230.578 41.6501L-247.337 25.1469Z",
    fill: "url(#paint19_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-176.267 25.1469L-159.506 8.64371L-156.778 11.3303L-150.021 4.67339L-159.506 -4.66315L-189.782 25.1469L-159.506 54.9616L-129.23 25.1469L-147.749 6.91575L-163.326 22.2545L-156.568 28.9068L-147.749 20.2226L-142.748 25.1469L-159.506 41.6501L-176.267 25.1469Z",
    fill: "url(#paint20_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.393 24.9482L-88.6328 8.4473L-85.9044 11.1339L-79.1479 4.47698L-88.6328 -4.86189L-118.909 24.9482L-88.6328 54.7629L-58.3569 24.9482L-76.8755 6.71701L-92.4529 22.0558L-85.6964 28.7104L-76.8755 20.0238L-71.8747 24.9482L-88.6328 41.4514L-105.393 24.9482Z",
    fill: "url(#paint21_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5197 25.1469L-17.7616 8.64371L-15.0333 11.3303L-8.27441 4.67339L-17.7616 -4.66315L-48.0351 25.1469L-17.7616 54.9616L12.5166 25.1469L-6.00195 6.91575L-21.5794 22.2545L-14.8229 28.9068L-6.00195 20.2226L-1.00116 25.1469L-17.7616 41.6501L-34.5197 25.1469Z",
    fill: "url(#paint22_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5502 25.1469L53.3106 8.64371L56.039 11.3303L62.7955 4.67339L53.3106 -4.66315L23.0348 25.1469L53.3106 54.9616L83.5865 25.1469L65.0679 6.91575L49.4905 22.2545L56.247 28.9068L65.0679 20.2226L70.0687 25.1469L53.3106 41.6501L36.5502 25.1469Z",
    fill: "url(#paint23_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.424 24.9482L124.182 8.4473L126.91 11.1339L133.669 4.47698L124.182 -4.86189L93.9083 24.9482L124.182 54.7629L154.46 24.9482L135.941 6.71701L120.364 22.0558L127.121 28.7104L135.941 20.0238L140.942 24.9482L124.182 41.4514L107.424 24.9482Z",
    fill: "url(#paint24_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.295 25.1469L195.055 8.64371L197.784 11.3303L204.54 4.67339L195.055 -4.66315L164.782 25.1469L195.055 54.9616L225.333 25.1469L206.813 6.91575L191.235 22.2545L197.994 28.9068L206.813 20.2226L211.816 25.1469L195.055 41.6501L178.295 25.1469Z",
    fill: "url(#paint25_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.367 25.1469L266.125 8.64371L268.854 11.3303L275.612 4.67339L266.125 -4.66315L235.852 25.1469L266.125 54.9616L296.403 25.1469L277.885 6.91575L262.307 22.2545L269.064 28.9068L277.885 20.2226L282.886 25.1469L266.125 41.6501L249.367 25.1469Z",
    fill: "url(#paint26_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.756 6.71701L333.179 22.0558L339.937 28.7104L348.756 20.0238L353.759 24.9482L336.999 41.4514L320.238 24.9482L336.999 8.4473L339.727 11.1339L346.484 4.47698L336.999 -4.86189L306.725 24.9482L336.999 54.7629L367.277 24.9482L348.756 6.71701Z",
    fill: "url(#paint27_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.448 63.7627L-253.967 45.5316L-269.544 60.8703L-262.788 67.5249L-253.967 58.8384L-248.966 63.7627L-265.727 80.2659L-282.485 63.7627L-265.727 47.2595L-262.998 49.9461L-256.239 43.2916L-265.727 33.9527L-296 63.7627L-265.727 93.5775L-235.448 63.7627Z",
    fill: "url(#paint28_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904 60.8703L375.661 67.5249L384.481 58.8384L389.482 63.7627L372.724 80.2659L355.964 63.7627L372.724 47.2595L375.453 49.9461L382.209 43.2916L372.724 33.9527L342.448 63.7627L372.724 93.5775L403 63.7627L384.481 45.5316L368.904 60.8703Z",
    fill: "url(#paint29_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.93 63.7627L-194.654 93.5775L-164.378 63.7627L-182.897 45.5316L-198.474 60.8703L-191.716 67.5249L-182.897 58.8384L-177.896 63.7627L-194.654 80.2659L-211.415 63.7627L-194.654 47.2595L-191.926 49.9461L-185.169 43.2916L-194.654 33.9527L-224.93 63.7627Z",
    fill: "url(#paint30_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-154.057 63.5663L-123.783 93.3787L-93.5049 63.5663L-112.023 45.3328L-127.601 60.6716L-120.844 67.3262L-112.023 58.642L-107.023 63.5663L-123.783 80.0695L-140.541 63.5663L-123.783 47.0631L-121.055 49.7497L-114.296 43.0928L-123.783 33.7539L-154.057 63.5663Z",
    fill: "url(#paint31_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-83.1831 63.7627L-52.9096 93.5775L-22.6314 63.7627L-41.15 45.5316L-56.7274 60.8703L-49.9709 67.5249L-41.15 58.8384L-36.1492 63.7627L-52.9096 80.2659L-69.67 63.7627L-52.9096 47.2595L-50.1813 49.9461L-43.4224 43.2916L-52.9096 33.9527L-83.1831 63.7627Z",
    fill: "url(#paint32_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.1132 63.7627L18.1626 93.5775L48.4384 63.7627L29.9199 45.5316L14.3425 60.8703L21.099 67.5249L29.9199 58.8384L34.9207 63.7627L18.1626 80.2659L1.40216 63.7627L18.1626 47.2595L20.8886 49.9461L27.6475 43.2916L18.1626 33.9527L-12.1132 63.7627Z",
    fill: "url(#paint33_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7603 63.5663L89.0338 93.3787L119.312 63.5663L100.793 45.3328L85.216 60.6716L91.9725 67.3262L100.793 58.642L105.794 63.5663L89.0338 80.0695L72.2733 63.5663L89.0338 47.0631L91.7621 49.7497L98.521 43.0928L89.0338 33.7539L58.7603 63.5663Z",
    fill: "url(#paint34_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.631 63.7627L159.907 93.5775L190.183 63.7627L171.665 45.5316L156.087 60.8703L162.846 67.5249L171.665 58.8384L176.665 63.7627L159.907 80.2659L143.147 63.7627L159.907 47.2595L162.636 49.9461L169.392 43.2916L159.907 33.9527L129.631 63.7627Z",
    fill: "url(#paint35_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.704 63.7627L230.977 93.5775L261.255 63.7627L242.737 45.5316L227.159 60.8703L233.916 67.5249L242.737 58.8384L247.738 63.7627L230.977 80.2659L214.219 63.7627L230.977 47.2595L233.705 49.9461L240.464 43.2916L230.977 33.9527L200.704 63.7627Z",
    fill: "url(#paint36_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09 63.5663L301.851 47.0631L304.579 49.7497L311.336 43.0928L301.851 33.7539L271.575 63.5663L301.851 93.3787L332.126 63.5663L313.608 45.3328L298.031 60.6716L304.789 67.3262L313.608 58.642L318.609 63.5663L301.851 80.0695L285.09 63.5663Z",
    fill: "url(#paint37_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230.578 132.298L-200.3 102.484L-218.819 84.2503L-234.396 99.589L-227.64 106.244L-218.819 97.5594L-213.818 102.484L-230.578 118.987L-247.337 102.484L-230.578 85.9805L-227.85 88.6672L-221.091 82.0103L-230.578 72.6737L-260.852 102.484L-230.578 132.298Z",
    fill: "url(#paint38_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-176.267 102.484L-159.506 85.9805L-156.778 88.6672L-150.021 82.0103L-159.506 72.6737L-189.782 102.484L-159.506 132.298L-129.23 102.484L-147.749 84.2503L-163.326 99.589L-156.568 106.244L-147.749 97.5594L-142.748 102.484L-159.506 118.987L-176.267 102.484Z",
    fill: "url(#paint39_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.393 102.285L-88.6328 85.7818L-85.9044 88.4684L-79.1479 81.8115L-88.6328 72.475L-118.909 102.285L-88.6328 132.1L-58.3569 102.285L-76.8755 84.0538L-92.4529 99.3926L-85.6964 106.045L-76.8755 97.3607L-71.8747 102.285L-88.6328 118.788L-105.393 102.285Z",
    fill: "url(#paint40_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5197 102.484L-17.7616 85.9805L-15.0333 88.6672L-8.27441 82.0103L-17.7616 72.6737L-48.0351 102.484L-17.7616 132.298L12.5166 102.484L-6.00195 84.2503L-21.5794 99.589L-14.8229 106.244L-6.00195 97.5594L-1.00116 102.484L-17.7616 118.987L-34.5197 102.484Z",
    fill: "url(#paint41_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5502 102.484L53.3106 85.9805L56.039 88.6672L62.7955 82.0103L53.3106 72.6737L23.0348 102.484L53.3106 132.298L83.5865 102.484L65.0679 84.2503L49.4905 99.589L56.247 106.244L65.0679 97.5594L70.0687 102.484L53.3106 118.987L36.5502 102.484Z",
    fill: "url(#paint42_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.424 102.285L124.182 85.7818L126.91 88.4684L133.669 81.8115L124.182 72.475L93.9083 102.285L124.182 132.1L154.46 102.285L135.941 84.0538L120.364 99.3926L127.121 106.045L135.941 97.3607L140.942 102.285L124.182 118.788L107.424 102.285Z",
    fill: "url(#paint43_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.295 102.484L195.055 85.9805L197.784 88.6672L204.54 82.0103L195.055 72.6737L164.782 102.484L195.055 132.298L225.333 102.484L206.813 84.2503L191.235 99.589L197.994 106.244L206.813 97.5594L211.816 102.484L195.055 118.987L178.295 102.484Z",
    fill: "url(#paint44_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.367 102.484L266.125 85.9805L268.854 88.6672L275.612 82.0103L266.125 72.6737L235.852 102.484L266.125 132.298L296.403 102.484L277.885 84.2503L262.307 99.589L269.064 106.244L277.885 97.5594L282.886 102.484L266.125 118.987L249.367 102.484Z",
    fill: "url(#paint45_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.238 102.285L336.999 85.7818L339.727 88.4684L346.484 81.8115L336.999 72.475L306.725 102.285L336.999 132.1L367.277 102.285L348.756 84.0538L333.179 99.3926L339.937 106.045L348.756 97.3607L353.759 102.285L336.999 118.788L320.238 102.285Z",
    fill: "url(#paint46_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.448 141.1L-253.967 122.868L-269.544 138.207L-262.788 144.859L-253.967 136.175L-248.966 141.1L-265.727 157.603L-282.485 141.1L-265.727 124.596L-262.998 127.283L-256.239 120.626L-265.727 111.29L-296 141.1L-265.727 170.914L-235.448 141.1Z",
    fill: "url(#paint47_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904 138.207L375.661 144.859L384.481 136.175L389.482 141.1L372.724 157.603L355.964 141.1L372.724 124.596L375.453 127.283L382.209 120.626L372.724 111.29L342.448 141.1L372.724 170.914L403 141.1L384.481 122.868L368.904 138.207Z",
    fill: "url(#paint48_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.93 141.1L-194.654 170.914L-164.378 141.1L-182.897 122.868L-198.474 138.207L-191.716 144.859L-182.897 136.175L-177.896 141.1L-194.654 157.603L-211.415 141.1L-194.654 124.596L-191.926 127.283L-185.169 120.626L-194.654 111.29L-224.93 141.1Z",
    fill: "url(#paint49_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-154.057 140.901L-123.783 170.716L-93.5049 140.901L-112.023 122.67L-127.601 138.008L-120.844 144.663L-112.023 135.977L-107.023 140.901L-123.783 157.404L-140.541 140.901L-123.783 124.4L-121.055 127.087L-114.296 120.43L-123.783 111.091L-154.057 140.901Z",
    fill: "url(#paint50_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-83.1831 141.1L-52.9096 170.914L-22.6314 141.1L-41.15 122.868L-56.7274 138.207L-49.9709 144.859L-41.15 136.175L-36.1492 141.1L-52.9096 157.603L-69.67 141.1L-52.9096 124.596L-50.1813 127.283L-43.4224 120.626L-52.9096 111.29L-83.1831 141.1Z",
    fill: "url(#paint51_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.1132 141.1L18.1626 170.914L48.4384 141.1L29.9199 122.868L14.3425 138.207L21.099 144.859L29.9199 136.175L34.9207 141.1L18.1626 157.603L1.40216 141.1L18.1626 124.596L20.8886 127.283L27.6475 120.626L18.1626 111.29L-12.1132 141.1Z",
    fill: "url(#paint52_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7603 140.901L89.0338 170.716L119.312 140.901L100.793 122.67L85.216 138.008L91.9725 144.663L100.793 135.977L105.794 140.901L89.0338 157.404L72.2733 140.901L89.0338 124.4L91.7621 127.087L98.521 120.43L89.0338 111.091L58.7603 140.901Z",
    fill: "url(#paint53_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.631 141.1L159.907 170.914L190.183 141.1L171.665 122.868L156.087 138.207L162.846 144.859L171.665 136.175L176.665 141.1L159.907 157.603L143.147 141.1L159.907 124.596L162.636 127.283L169.392 120.626L159.907 111.29L129.631 141.1Z",
    fill: "url(#paint54_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.704 141.1L230.977 170.914L261.255 141.1L242.737 122.868L227.159 138.207L233.916 144.859L242.737 136.175L247.738 141.1L230.977 157.603L214.219 141.1L230.977 124.596L233.705 127.283L240.464 120.626L230.977 111.29L200.704 141.1Z",
    fill: "url(#paint55_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09 140.901L301.851 124.4L304.579 127.087L311.336 120.43L301.851 111.091L271.575 140.901L301.851 170.716L332.126 140.901L313.608 122.67L298.031 138.008L304.789 144.663L313.608 135.977L318.609 140.901L301.851 157.404L285.09 140.901Z",
    fill: "url(#paint56_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230.578 209.437L-200.3 179.622L-218.819 161.388L-234.396 176.727L-227.64 183.382L-218.819 174.698L-213.818 179.622L-230.578 196.125L-247.337 179.622L-230.578 163.119L-227.85 165.805L-221.091 159.148L-230.578 149.812L-260.852 179.622L-230.578 209.437Z",
    fill: "url(#paint57_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-176.267 179.622L-159.506 163.119L-156.778 165.805L-150.021 159.148L-159.506 149.812L-189.782 179.622L-159.506 209.437L-129.23 179.622L-147.749 161.388L-163.326 176.727L-156.568 183.382L-147.749 174.698L-142.748 179.622L-159.506 196.125L-176.267 179.622Z",
    fill: "url(#paint58_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105.393 179.423L-88.6328 162.92L-85.9044 165.607L-79.1479 158.95L-88.6328 149.613L-118.909 179.423L-88.6328 209.238L-58.3569 179.423L-76.8755 161.192L-92.4529 176.531L-85.6964 183.183L-76.8755 174.499L-71.8747 179.423L-88.6328 195.926L-105.393 179.423Z",
    fill: "url(#paint59_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5197 179.622L-17.7616 163.119L-15.0333 165.805L-8.27441 159.148L-17.7616 149.812L-48.0351 179.622L-17.7616 209.437L12.5166 179.622L-6.00195 161.388L-21.5794 176.727L-14.8229 183.382L-6.00195 174.698L-1.00116 179.622L-17.7616 196.125L-34.5197 179.622Z",
    fill: "url(#paint60_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5502 179.622L53.3106 163.119L56.039 165.805L62.7955 159.148L53.3106 149.812L23.0348 179.622L53.3106 209.437L83.5865 179.622L65.0679 161.388L49.4905 176.727L56.247 183.382L65.0679 174.698L70.0687 179.622L53.3106 196.125L36.5502 179.622Z",
    fill: "url(#paint61_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.424 179.423L124.182 162.92L126.91 165.607L133.669 158.95L124.182 149.613L93.9083 179.423L124.182 209.238L154.46 179.423L135.941 161.192L120.364 176.531L127.121 183.183L135.941 174.499L140.942 179.423L124.182 195.926L107.424 179.423Z",
    fill: "url(#paint62_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.295 179.622L195.055 163.119L197.784 165.805L204.54 159.148L195.055 149.812L164.782 179.622L195.055 209.437L225.333 179.622L206.813 161.388L191.235 176.727L197.994 183.382L206.813 174.698L211.816 179.622L195.055 196.125L178.295 179.622Z",
    fill: "url(#paint63_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.367 179.622L266.125 163.119L268.854 165.805L275.612 159.148L266.125 149.812L235.852 179.622L266.125 209.437L296.403 179.622L277.885 161.388L262.307 176.727L269.064 183.382L277.885 174.698L282.886 179.622L266.125 196.125L249.367 179.622Z",
    fill: "url(#paint64_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.238 179.423L336.999 162.92L339.727 165.607L346.484 158.95L336.999 149.613L306.725 179.423L336.999 209.238L367.277 179.423L348.756 161.192L333.179 176.531L339.937 183.183L348.756 174.499L353.759 179.423L336.999 195.926L320.238 179.423Z",
    fill: "url(#paint65_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.448 218.238L-253.967 200.007L-269.544 215.345L-262.788 221.998L-253.967 213.313L-248.966 218.238L-265.727 234.741L-282.485 218.238L-265.727 201.734L-262.998 204.421L-256.239 197.764L-265.727 188.428L-296 218.238L-265.727 248.052L-235.448 218.238Z",
    fill: "url(#paint66_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904 215.345L375.661 221.998L384.481 213.313L389.482 218.238L372.724 234.741L355.964 218.238L372.724 201.734L375.453 204.421L382.209 197.764L372.724 188.428L342.448 218.238L372.724 248.052L403 218.238L384.481 200.007L368.904 215.345Z",
    fill: "url(#paint67_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-194.654 248.052L-164.378 218.238L-182.897 200.007L-198.474 215.345L-191.716 221.998L-182.897 213.313L-177.896 218.238L-194.654 234.741L-211.415 218.238L-194.654 201.734L-191.926 204.421L-185.169 197.764L-194.654 188.428L-224.93 218.238L-194.654 248.052Z",
    fill: "url(#paint68_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-154.057 218.041L-123.783 247.854L-93.5049 218.041L-112.023 199.808L-127.601 215.147L-120.844 221.801L-112.023 213.115L-107.023 218.041L-123.783 234.542L-140.541 218.041L-123.783 201.538L-121.055 204.225L-114.296 197.568L-123.783 188.229L-154.057 218.041Z",
    fill: "url(#paint69_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-83.1831 218.238L-52.9096 248.052L-22.6314 218.238L-41.15 200.007L-56.7274 215.345L-49.9709 221.998L-41.15 213.313L-36.1492 218.238L-52.9096 234.741L-69.67 218.238L-52.9096 201.734L-50.1813 204.421L-43.4224 197.764L-52.9096 188.428L-83.1831 218.238Z",
    fill: "url(#paint70_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.1132 218.238L18.1626 248.052L48.4384 218.238L29.9199 200.007L14.3425 215.345L21.099 221.998L29.9199 213.313L34.9207 218.238L18.1626 234.741L1.40216 218.238L18.1626 201.734L20.8886 204.421L27.6475 197.764L18.1626 188.428L-12.1132 218.238Z",
    fill: "url(#paint71_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7603 218.041L89.0338 247.854L119.312 218.041L100.793 199.808L85.216 215.147L91.9725 221.801L100.793 213.115L105.794 218.041L89.0338 234.542L72.2733 218.041L89.0338 201.538L91.7621 204.225L98.521 197.568L89.0338 188.229L58.7603 218.041Z",
    fill: "url(#paint72_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.631 218.238L159.907 248.052L190.183 218.238L171.665 200.007L156.087 215.345L162.846 221.998L171.665 213.313L176.665 218.238L159.907 234.741L143.147 218.238L159.907 201.734L162.636 204.421L169.392 197.764L159.907 188.428L129.631 218.238Z",
    fill: "url(#paint73_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.219 218.238L230.977 201.734L233.705 204.421L240.464 197.764L230.977 188.428L200.704 218.238L230.977 248.052L261.255 218.238L242.737 200.007L227.159 215.345L233.916 221.998L242.737 213.313L247.738 218.238L230.977 234.741L214.219 218.238Z",
    fill: "url(#paint74_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09 218.041L301.851 201.538L304.579 204.225L311.336 197.568L301.851 188.229L271.575 218.041L301.851 247.854L332.126 218.041L313.608 199.808L298.031 215.147L304.789 221.801L313.608 213.115L318.609 218.041L301.851 234.542L285.09 218.041Z",
    fill: "url(#paint75_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230.578 286.771L-200.3 256.959L-218.819 238.725L-234.396 254.064L-227.64 260.719L-218.819 252.034L-213.818 256.959L-230.578 273.462L-247.337 256.959L-230.578 240.456L-227.85 243.142L-221.091 236.485L-230.578 227.146L-260.852 256.959L-230.578 286.771Z",
    fill: "url(#paint76_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-159.506 286.771L-129.23 256.959L-147.749 238.725L-163.326 254.064L-156.568 260.719L-147.749 252.034L-142.748 256.959L-159.506 273.462L-176.267 256.959L-159.506 240.456L-156.778 243.142L-150.021 236.485L-159.506 227.146L-189.782 256.959L-159.506 286.771Z",
    fill: "url(#paint77_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.3569 256.76L-76.8755 238.526L-92.4529 253.868L-85.6964 260.52L-76.8755 251.836L-71.8747 256.76L-88.6328 273.263L-105.393 256.76L-88.6328 240.257L-85.9044 242.943L-79.1479 236.286L-88.6328 226.95L-118.909 256.76L-88.6328 286.575L-58.3569 256.76Z",
    fill: "url(#paint78_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5166 256.959L-6.00195 238.725L-21.5794 254.064L-14.8229 260.719L-6.00195 252.034L-1.00116 256.959L-17.7616 273.462L-34.5197 256.959L-17.7616 240.456L-15.0333 243.142L-8.27441 236.485L-17.7616 227.146L-48.0351 256.959L-17.7616 286.771L12.5166 256.959Z",
    fill: "url(#paint79_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5865 256.959L65.0679 238.725L49.4905 254.064L56.247 260.719L65.0679 252.034L70.0687 256.959L53.3106 273.462L36.5502 256.959L53.3106 240.456L56.039 243.142L62.7955 236.485L53.3106 227.146L23.0348 256.959L53.3106 286.771L83.5865 256.959Z",
    fill: "url(#paint80_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46 256.76L135.941 238.526L120.364 253.868L127.121 260.52L135.941 251.836L140.942 256.76L124.182 273.263L107.424 256.76L124.182 240.257L126.91 242.943L133.669 236.286L124.182 226.95L93.9083 256.76L124.182 286.575L154.46 256.76Z",
    fill: "url(#paint81_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.333 256.959L206.813 238.725L191.235 254.064L197.994 260.719L206.813 252.034L211.816 256.959L195.055 273.462L178.295 256.959L195.055 240.456L197.784 243.142L204.54 236.485L195.055 227.146L164.782 256.959L195.055 286.771L225.333 256.959Z",
    fill: "url(#paint82_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.367 256.959L266.125 240.456L268.854 243.142L275.612 236.485L266.125 227.146L235.852 256.959L266.125 286.771L296.403 256.959L277.885 238.725L262.307 254.064L269.064 260.719L277.885 252.034L282.886 256.959L266.125 273.462L249.367 256.959Z",
    fill: "url(#paint83_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.238 256.76L336.999 240.257L339.727 242.943L346.484 236.286L336.999 226.95L306.725 256.76L336.999 286.575L367.277 256.76L348.756 238.526L333.179 253.868L339.937 260.52L348.756 251.836L353.759 256.76L336.999 273.263L320.238 256.76Z",
    fill: "url(#paint84_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.448 295.575L-253.967 277.341L-269.544 292.682L-262.788 299.334L-253.967 290.65L-248.966 295.575L-265.727 312.078L-282.485 295.575L-265.727 279.071L-262.998 281.758L-256.239 275.101L-265.727 265.764L-296 295.575L-265.727 325.389L-235.448 295.575Z",
    fill: "url(#paint85_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904 292.682L375.661 299.334L384.481 290.65L389.482 295.575L372.724 312.078L355.964 295.575L372.724 279.071L375.453 281.758L382.209 275.101L372.724 265.764L342.448 295.575L372.724 325.389L403 295.575L384.481 277.341L368.904 292.682Z",
    fill: "url(#paint86_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-194.654 325.389L-164.378 295.575L-182.897 277.341L-198.474 292.682L-191.716 299.334L-182.897 290.65L-177.896 295.575L-194.654 312.078L-211.415 295.575L-194.654 279.071L-191.926 281.758L-185.169 275.101L-194.654 265.764L-224.93 295.575L-194.654 325.389Z",
    fill: "url(#paint87_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.5049 295.376L-112.023 277.145L-127.601 292.483L-120.844 299.138L-112.023 290.451L-107.023 295.376L-123.783 311.879L-140.541 295.376L-123.783 278.873L-121.055 281.559L-114.296 274.902L-123.783 265.566L-154.057 295.376L-123.783 325.191L-93.5049 295.376Z",
    fill: "url(#paint88_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.6314 295.575L-41.15 277.341L-56.7274 292.682L-49.9709 299.334L-41.15 290.65L-36.1492 295.575L-52.9096 312.078L-69.67 295.575L-52.9096 279.071L-50.1813 281.758L-43.4224 275.101L-52.9096 265.764L-83.1831 295.575L-52.9096 325.389L-22.6314 295.575Z",
    fill: "url(#paint89_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4384 295.575L29.9199 277.341L14.3425 292.682L21.099 299.334L29.9199 290.65L34.9207 295.575L18.1626 312.078L1.40216 295.575L18.1626 279.071L20.8886 281.758L27.6475 275.101L18.1626 265.764L-12.1132 295.575L18.1626 325.389L48.4384 295.575Z",
    fill: "url(#paint90_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.312 295.376L100.793 277.145L85.216 292.483L91.9725 299.138L100.793 290.451L105.794 295.376L89.0338 311.879L72.2733 295.376L89.0338 278.873L91.7621 281.559L98.521 274.902L89.0338 265.566L58.7603 295.376L89.0338 325.191L119.312 295.376Z",
    fill: "url(#paint91_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.183 295.575L171.665 277.341L156.087 292.682L162.846 299.334L171.665 290.65L176.665 295.575L159.907 312.078L143.147 295.575L159.907 279.071L162.636 281.758L169.392 275.101L159.907 265.764L129.631 295.575L159.907 325.389L190.183 295.575Z",
    fill: "url(#paint92_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.255 295.575L242.737 277.341L227.159 292.682L233.916 299.334L242.737 290.65L247.738 295.575L230.977 312.078L214.219 295.575L230.977 279.071L233.705 281.758L240.464 275.101L230.977 265.764L200.704 295.575L230.977 325.389L261.255 295.575Z",
    fill: "url(#paint93_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09 295.376L301.851 278.873L304.579 281.559L311.336 274.902L301.851 265.566L271.575 295.376L301.851 325.191L332.126 295.376L313.608 277.145L298.031 292.483L304.789 299.138L313.608 290.451L318.609 295.376L301.851 311.879L285.09 295.376Z",
    fill: "url(#paint94_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230.578 363.909L-200.3 334.097L-218.819 315.863L-234.396 331.202L-227.64 337.857L-218.819 329.173L-213.818 334.097L-230.578 350.6L-247.337 334.097L-230.578 317.594L-227.85 320.28L-221.091 313.623L-230.578 304.284L-260.852 334.097L-230.578 363.909Z",
    fill: "url(#paint95_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.23 334.097L-147.749 315.863L-163.326 331.202L-156.568 337.857L-147.749 329.173L-142.748 334.097L-159.506 350.6L-176.267 334.097L-159.506 317.594L-156.778 320.28L-150.021 313.623L-159.506 304.284L-189.782 334.097L-159.506 363.909L-129.23 334.097Z",
    fill: "url(#paint96_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.3569 333.898L-76.8755 315.667L-92.4529 331.006L-85.6964 337.658L-76.8755 328.974L-71.8747 333.898L-88.6328 350.401L-105.393 333.898L-88.6328 317.395L-85.9044 320.081L-79.1479 313.425L-88.6328 304.088L-118.909 333.898L-88.6328 363.713L-58.3569 333.898Z",
    fill: "url(#paint97_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5166 334.097L-6.00195 315.863L-21.5794 331.202L-14.8229 337.857L-6.00195 329.173L-1.00116 334.097L-17.7616 350.6L-34.5197 334.097L-17.7616 317.594L-15.0333 320.28L-8.27441 313.623L-17.7616 304.284L-48.0351 334.097L-17.7616 363.909L12.5166 334.097Z",
    fill: "url(#paint98_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5865 334.097L65.0679 315.863L49.4905 331.202L56.247 337.857L65.0679 329.173L70.0687 334.097L53.3106 350.6L36.5502 334.097L53.3106 317.594L56.039 320.28L62.7955 313.623L53.3106 304.284L23.0348 334.097L53.3106 363.909L83.5865 334.097Z",
    fill: "url(#paint99_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46 333.898L135.941 315.667L120.364 331.006L127.121 337.658L135.941 328.974L140.942 333.898L124.182 350.401L107.424 333.898L124.182 317.395L126.91 320.081L133.669 313.425L124.182 304.088L93.9083 333.898L124.182 363.713L154.46 333.898Z",
    fill: "url(#paint100_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.333 334.097L206.813 315.863L191.235 331.202L197.994 337.857L206.813 329.173L211.816 334.097L195.055 350.6L178.295 334.097L195.055 317.594L197.784 320.28L204.54 313.623L195.055 304.284L164.782 334.097L195.055 363.909L225.333 334.097Z",
    fill: "url(#paint101_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.403 334.097L277.885 315.863L262.307 331.202L269.064 337.857L277.885 329.173L282.886 334.097L266.125 350.6L249.367 334.097L266.125 317.594L268.854 320.28L275.612 313.623L266.125 304.284L235.852 334.097L266.125 363.909L296.403 334.097Z",
    fill: "url(#paint102_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.238 333.898L336.999 317.395L339.727 320.081L346.484 313.425L336.999 304.088L306.725 333.898L336.999 363.713L367.277 333.898L348.756 315.667L333.179 331.006L339.937 337.658L348.756 328.974L353.759 333.898L336.999 350.401L320.238 333.898Z",
    fill: "url(#paint103_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.448 372.713L-253.967 354.479L-269.544 369.82L-262.788 376.473L-253.967 367.788L-248.966 372.713L-265.727 389.216L-282.485 372.713L-265.727 356.209L-262.998 358.896L-256.239 352.239L-265.727 342.903L-296 372.713L-265.727 402.527L-235.448 372.713Z",
    fill: "url(#paint104_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904 369.82L375.661 376.473L384.481 367.788L389.482 372.713L372.724 389.216L355.964 372.713L372.724 356.209L375.453 358.896L382.209 352.239L372.724 342.903L342.448 372.713L372.724 402.527L403 372.713L384.481 354.479L368.904 369.82Z",
    fill: "url(#paint105_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-194.654 402.527L-164.378 372.713L-182.897 354.479L-198.474 369.82L-191.716 376.473L-182.897 367.788L-177.896 372.713L-194.654 389.216L-211.415 372.713L-194.654 356.209L-191.926 358.896L-185.169 352.239L-194.654 342.903L-224.93 372.713L-194.654 402.527Z",
    fill: "url(#paint106_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.5049 372.514L-112.023 354.283L-127.601 369.621L-120.844 376.276L-112.023 367.59L-107.023 372.514L-123.783 389.017L-140.541 372.514L-123.783 356.011L-121.055 358.697L-114.296 352.04L-123.783 342.704L-154.057 372.514L-123.783 402.329L-93.5049 372.514Z",
    fill: "url(#paint107_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.6314 372.713L-41.15 354.479L-56.7274 369.82L-49.9709 376.473L-41.15 367.788L-36.1492 372.713L-52.9096 389.216L-69.67 372.713L-52.9096 356.209L-50.1813 358.896L-43.4224 352.239L-52.9096 342.903L-83.1831 372.713L-52.9096 402.527L-22.6314 372.713Z",
    fill: "url(#paint108_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4384 372.713L29.9199 354.479L14.3425 369.82L21.099 376.473L29.9199 367.788L34.9207 372.713L18.1626 389.216L1.40216 372.713L18.1626 356.209L20.8886 358.896L27.6475 352.239L18.1626 342.903L-12.1132 372.713L18.1626 402.527L48.4384 372.713Z",
    fill: "url(#paint109_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.312 372.514L100.793 354.283L85.216 369.621L91.9725 376.276L100.793 367.59L105.794 372.514L89.0338 389.017L72.2733 372.514L89.0338 356.011L91.7621 358.697L98.521 352.04L89.0338 342.704L58.7603 372.514L89.0338 402.329L119.312 372.514Z",
    fill: "url(#paint110_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.183 372.713L171.665 354.479L156.087 369.82L162.846 376.473L171.665 367.788L176.665 372.713L159.907 389.216L143.147 372.713L159.907 356.209L162.636 358.896L169.392 352.239L159.907 342.903L129.631 372.713L159.907 402.527L190.183 372.713Z",
    fill: "url(#paint111_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.255 372.713L242.737 354.479L227.159 369.82L233.916 376.473L242.737 367.788L247.738 372.713L230.977 389.216L214.219 372.713L230.977 356.209L233.705 358.896L240.464 352.239L230.977 342.903L200.704 372.713L230.977 402.527L261.255 372.713Z",
    fill: "url(#paint112_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09 372.514L301.851 356.011L304.579 358.697L311.336 352.04L301.851 342.704L271.575 372.514L301.851 402.329L332.126 372.514L313.608 354.283L298.031 369.621L304.789 376.276L313.608 367.59L318.609 372.514L301.851 389.017L285.09 372.514Z",
    fill: "url(#paint113_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230.578 441.246L-200.3 411.434L-218.819 393.2L-234.396 408.539L-227.64 415.194L-218.819 406.507L-213.818 411.434L-230.578 427.935L-247.337 411.434L-230.578 394.93L-227.85 397.617L-221.091 390.96L-230.578 381.621L-260.852 411.434L-230.578 441.246Z",
    fill: "url(#paint114_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-129.23 411.434L-147.749 393.2L-163.326 408.539L-156.568 415.194L-147.749 406.507L-142.748 411.434L-159.506 427.935L-176.267 411.434L-159.506 394.93L-156.778 397.617L-150.021 390.96L-159.506 381.621L-189.782 411.434L-159.506 441.246L-129.23 411.434Z",
    fill: "url(#paint115_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.3569 411.235L-76.8755 393.001L-92.4529 408.34L-85.6964 414.995L-76.8755 406.311L-71.8747 411.235L-88.6328 427.738L-105.393 411.235L-88.6328 394.732L-85.9044 397.418L-79.1479 390.761L-88.6328 381.423L-118.909 411.235L-88.6328 441.047L-58.3569 411.235Z",
    fill: "url(#paint116_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5166 411.434L-6.00195 393.2L-21.5794 408.539L-14.8229 415.194L-6.00195 406.507L-1.00116 411.434L-17.7616 427.935L-34.5197 411.434L-17.7616 394.93L-15.0333 397.617L-8.27441 390.96L-17.7616 381.621L-48.0351 411.434L-17.7616 441.246L12.5166 411.434Z",
    fill: "url(#paint117_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5865 411.434L65.0679 393.2L49.4905 408.539L56.247 415.194L65.0679 406.507L70.0687 411.434L53.3106 427.935L36.5502 411.434L53.3106 394.93L56.039 397.617L62.7955 390.96L53.3106 381.621L23.0348 411.434L53.3106 441.246L83.5865 411.434Z",
    fill: "url(#paint118_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46 411.235L135.941 393.001L120.364 408.34L127.121 414.995L135.941 406.311L140.942 411.235L124.182 427.738L107.424 411.235L124.182 394.732L126.91 397.418L133.669 390.761L124.182 381.423L93.9083 411.235L124.182 441.047L154.46 411.235Z",
    fill: "url(#paint119_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.333 411.434L206.813 393.2L191.235 408.539L197.994 415.194L206.813 406.507L211.816 411.434L195.055 427.935L178.295 411.434L195.055 394.93L197.784 397.617L204.54 390.96L195.055 381.621L164.782 411.434L195.055 441.246L225.333 411.434Z",
    fill: "url(#paint120_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.403 411.434L277.885 393.2L262.307 408.539L269.064 415.194L277.885 406.507L282.886 411.434L266.125 427.935L249.367 411.434L266.125 394.93L268.854 397.617L275.612 390.96L266.125 381.621L235.852 411.434L266.125 441.246L296.403 411.434Z",
    fill: "url(#paint121_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.238 411.235L336.999 394.732L339.727 397.418L346.484 390.761L336.999 381.423L306.725 411.235L336.999 441.047L367.277 411.235L348.756 393.001L333.179 408.34L339.937 414.995L348.756 406.311L353.759 411.235L336.999 427.738L320.238 411.235Z",
    fill: "url(#paint122_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235.448 450.049L-253.967 431.816L-269.544 447.155L-262.788 453.809L-253.967 445.125L-248.966 450.049L-265.727 466.553L-282.485 450.049L-265.727 433.546L-262.998 436.233L-256.239 429.576L-265.727 420.237L-296 450.049L-265.727 479.862L-235.448 450.049Z",
    fill: "url(#paint123_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904 447.155L375.661 453.809L384.481 445.125L389.482 450.049L372.724 466.553L355.964 450.049L372.724 433.546L375.453 436.233L382.209 429.576L372.724 420.237L342.448 450.049L372.724 479.862L403 450.049L384.481 431.816L368.904 447.155Z",
    fill: "url(#paint124_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-164.378 450.049L-182.897 431.816L-198.474 447.155L-191.716 453.809L-182.897 445.125L-177.896 450.049L-194.654 466.553L-211.415 450.049L-194.654 433.546L-191.926 436.233L-185.169 429.576L-194.654 420.237L-224.93 450.049L-194.654 479.862L-164.378 450.049Z",
    fill: "url(#paint125_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.5049 449.851L-112.023 431.62L-127.601 446.958L-120.844 453.611L-112.023 444.926L-107.023 449.851L-123.783 466.354L-140.541 449.851L-123.783 433.348L-121.055 436.034L-114.296 429.377L-123.783 420.041L-154.057 449.851L-123.783 479.666L-93.5049 449.851Z",
    fill: "url(#paint126_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.6314 450.049L-41.15 431.816L-56.7274 447.155L-49.9709 453.809L-41.15 445.125L-36.1492 450.049L-52.9096 466.553L-69.67 450.049L-52.9096 433.546L-50.1813 436.233L-43.4224 429.576L-52.9096 420.237L-83.1831 450.049L-52.9096 479.862L-22.6314 450.049Z",
    fill: "url(#paint127_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4384 450.049L29.9199 431.816L14.3425 447.155L21.099 453.809L29.9199 445.125L34.9207 450.049L18.1626 466.553L1.40216 450.049L18.1626 433.546L20.8886 436.233L27.6475 429.576L18.1626 420.237L-12.1132 450.049L18.1626 479.862L48.4384 450.049Z",
    fill: "url(#paint128_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.312 449.851L100.793 431.62L85.216 446.958L91.9725 453.611L100.793 444.926L105.794 449.851L89.0338 466.354L72.2733 449.851L89.0338 433.348L91.7621 436.034L98.521 429.377L89.0338 420.041L58.7603 449.851L89.0338 479.666L119.312 449.851Z",
    fill: "url(#paint129_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.183 450.049L171.665 431.816L156.087 447.155L162.846 453.809L171.665 445.125L176.665 450.049L159.907 466.553L143.147 450.049L159.907 433.546L162.636 436.233L169.392 429.576L159.907 420.237L129.631 450.049L159.907 479.862L190.183 450.049Z",
    fill: "url(#paint130_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.255 450.049L242.737 431.816L227.159 447.155L233.916 453.809L242.737 445.125L247.738 450.049L230.977 466.553L214.219 450.049L230.977 433.546L233.705 436.233L240.464 429.576L230.977 420.237L200.704 450.049L230.977 479.862L261.255 450.049Z",
    fill: "url(#paint131_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.126 449.851L313.608 431.62L298.031 446.958L304.789 453.611L313.608 444.926L318.609 449.851L301.851 466.354L285.09 449.851L301.851 433.348L304.579 436.034L311.336 429.377L301.851 420.041L271.575 449.851L301.851 479.666L332.126 449.851Z",
    fill: "url(#paint132_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-218.819 470.338L-234.396 485.677L-227.64 492.332L-218.819 483.647L-213.818 488.572L-230.578 505.075L-247.337 488.572L-230.578 472.069L-227.85 474.755L-221.091 468.098L-230.578 458.759L-260.852 488.572L-230.578 518.384L-200.3 488.572L-218.819 470.338Z",
    fill: "url(#paint133_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.749 470.338L-163.326 485.677L-156.568 492.332L-147.749 483.647L-142.748 488.572L-159.506 505.075L-176.267 488.572L-159.506 472.069L-156.778 474.755L-150.021 468.098L-159.506 458.759L-189.782 488.572L-159.506 518.384L-129.23 488.572L-147.749 470.338Z",
    fill: "url(#paint134_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.8755 470.14L-92.4529 485.478L-85.6964 492.133L-76.8755 483.449L-71.8747 488.373L-88.6328 504.876L-105.393 488.373L-88.6328 471.87L-85.9044 474.556L-79.1479 467.9L-88.6328 458.563L-118.909 488.373L-88.6328 518.188L-58.3569 488.373L-76.8755 470.14Z",
    fill: "url(#paint135_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.00195 470.338L-21.5794 485.677L-14.8229 492.332L-6.00195 483.647L-1.00116 488.572L-17.7616 505.075L-34.5197 488.572L-17.7616 472.069L-15.0333 474.755L-8.27441 468.098L-17.7616 458.759L-48.0351 488.572L-17.7616 518.384L12.5166 488.572L-6.00195 470.338Z",
    fill: "url(#paint136_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0679 470.338L49.4905 485.677L56.247 492.332L65.0679 483.647L70.0687 488.572L53.3106 505.075L36.5502 488.572L53.3106 472.069L56.039 474.755L62.7955 468.098L53.3106 458.759L23.0348 488.572L53.3106 518.384L83.5865 488.572L65.0679 470.338Z",
    fill: "url(#paint137_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.941 470.14L120.364 485.478L127.121 492.133L135.941 483.449L140.942 488.373L124.182 504.876L107.424 488.373L124.182 471.87L126.91 474.556L133.669 467.9L124.182 458.563L93.9083 488.373L124.182 518.188L154.46 488.373L135.941 470.14Z",
    fill: "url(#paint138_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.813 470.338L191.235 485.677L197.994 492.332L206.813 483.647L211.816 488.572L195.055 505.075L178.295 488.572L195.055 472.069L197.784 474.755L204.54 468.098L195.055 458.759L164.782 488.572L195.055 518.384L225.333 488.572L206.813 470.338Z",
    fill: "url(#paint139_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.885 470.338L262.307 485.677L269.064 492.332L277.885 483.647L282.886 488.572L266.125 505.075L249.367 488.572L266.125 472.069L268.854 474.755L275.612 468.098L266.125 458.759L235.852 488.572L266.125 518.384L296.403 488.572L277.885 470.338Z",
    fill: "url(#paint140_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.756 470.14L333.179 485.478L339.937 492.133L348.756 483.449L353.759 488.373L336.999 504.876L320.238 488.373L336.999 471.87L339.727 474.556L346.484 467.9L336.999 458.563L306.725 488.373L336.999 518.188L367.277 488.373L348.756 470.14Z",
    fill: "url(#paint141_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269.544 524.293L-262.788 530.947L-253.967 522.263L-248.966 527.188L-265.727 543.691L-282.485 527.188L-265.727 510.684L-262.998 513.371L-256.239 506.714L-265.727 497.375L-296 527.188L-265.727 557L-235.448 527.188L-253.967 508.954L-269.544 524.293Z",
    fill: "url(#paint142_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904 524.293L375.661 530.947L384.481 522.263L389.482 527.188L372.724 543.691L355.964 527.188L372.724 510.684L375.453 513.371L382.209 506.714L372.724 497.375L342.448 527.188L372.724 557L403 527.188L384.481 508.954L368.904 524.293Z",
    fill: "url(#paint143_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-198.474 524.293L-191.716 530.947L-182.897 522.263L-177.896 527.188L-194.654 543.691L-211.415 527.188L-194.654 510.684L-191.926 513.371L-185.169 506.714L-194.654 497.375L-224.93 527.188L-194.654 557L-164.378 527.188L-182.897 508.954L-198.474 524.293Z",
    fill: "url(#paint144_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-127.601 524.096L-120.844 530.749L-112.023 522.065L-107.023 526.989L-123.783 543.492L-140.541 526.989L-123.783 510.486L-121.055 513.172L-114.296 506.515L-123.783 497.179L-154.057 526.989L-123.783 556.804L-93.5049 526.989L-112.023 508.758L-127.601 524.096Z",
    fill: "url(#paint145_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.7274 524.293L-49.9709 530.947L-41.15 522.263L-36.1492 527.188L-52.9096 543.691L-69.67 527.188L-52.9096 510.684L-50.1813 513.371L-43.4224 506.714L-52.9096 497.375L-83.1831 527.188L-52.9096 557L-22.6314 527.188L-41.15 508.954L-56.7274 524.293Z",
    fill: "url(#paint146_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3425 524.293L21.099 530.947L29.9199 522.263L34.9207 527.188L18.1626 543.691L1.40216 527.188L18.1626 510.684L20.8886 513.371L27.6475 506.714L18.1626 497.375L-12.1132 527.188L18.1626 557L48.4384 527.188L29.9199 508.954L14.3425 524.293Z",
    fill: "url(#paint147_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.216 524.096L91.9725 530.749L100.793 522.065L105.794 526.989L89.0338 543.492L72.2733 526.989L89.0338 510.486L91.7621 513.172L98.521 506.515L89.0338 497.179L58.7603 526.989L89.0338 556.804L119.312 526.989L100.793 508.758L85.216 524.096Z",
    fill: "url(#paint148_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.087 524.293L162.846 530.947L171.665 522.263L176.665 527.188L159.907 543.691L143.147 527.188L159.907 510.684L162.636 513.371L169.392 506.714L159.907 497.375L129.631 527.188L159.907 557L190.183 527.188L171.665 508.954L156.087 524.293Z",
    fill: "url(#paint149_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.159 524.293L233.916 530.947L242.737 522.263L247.738 527.188L230.977 543.691L214.219 527.188L230.977 510.684L233.705 513.371L240.464 506.714L230.977 497.375L200.704 527.188L230.977 557L261.255 527.188L242.737 508.954L227.159 524.293Z",
    fill: "url(#paint150_linear_224_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.031 524.096L304.789 530.749L313.608 522.065L318.609 526.989L301.851 543.492L285.09 526.989L301.851 510.486L304.579 513.172L311.336 506.515L301.851 497.179L271.575 526.989L301.851 556.804L332.126 526.989L313.608 508.758L298.031 524.096Z",
    fill: "url(#paint151_linear_224_625)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_224_625",
    x1: 403,
    y1: 237,
    x2: -5.76235,
    y2: 267.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayPatternLeft);
export default __webpack_public_path__ + "static/media/gatewayPatternLeft.53d3f95c1037df939f5fd29b0b125cdc.svg";
export { ForwardRef as ReactComponent };